import { css } from '@mui/material'

export const imageOptimizeRendering = css`
  image-rendering: optimizeSpeed; // Legal fallback
  image-rendering: -moz-crisp-edges; // Firefox
  image-rendering: -o-crisp-edges; // Opera
  image-rendering: -webkit-optimize-contrast; // Safari
  image-rendering: optimize-contrast; // CSS3 Proposed
  image-rendering: crisp-edges; // CSS4 Proposed
`
